import {Component, inject, DestroyRef} from '@angular/core';
import {ItrentDebugService} from '../../../services/http/admin/itrent-debug.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

@Component({
  selector: 'app-debug-itrent-employee',
  templateUrl: './debug-itrent-employee.component.html',
  styleUrls: ['./debug-itrent-employee.component.less'],
  imports: [SHARED_IMPORTS]
})
export class DebugItrentEmployeeComponent {
  private itrentDebugService = inject(ItrentDebugService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  employeeId: string;
  rawEmployeeResponse: string;

  getRawResponseForEmployee() {
    this.itrentDebugService.getRawResponseForEmployee(this.employeeId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: response => this.rawEmployeeResponse = response
            });
  }
}
